module.exports = __webpack_public_path__ + "assets/icons/baseline-tonality-24px-d578.svg";